import { useState as d, useRef as u, useCallback as a, useLayoutEffect as f } from "react";
const c = (e) => {
  const n = e?.borderBoxSize?.at(0);
  return {
    blockSize: n?.blockSize ?? e?.contentRect.height,
    inlineSize: n?.inlineSize ?? e?.contentRect.width
  };
}, v = () => {
  const [e, n] = d(null), t = u(null), o = u(null), s = a(() => o.current?.disconnect(), []), l = a(() => {
    o.current = new ResizeObserver(([i]) => {
      n((r) => {
        if (!r)
          return i;
        const S = c(r), b = c(i);
        return r.target === i.target && S.blockSize === b.blockSize && S.inlineSize === b.inlineSize ? r : i;
      });
    }), t.current && o.current.observe(t.current);
  }, [t]);
  f(() => (l(), () => s()), [s, l]);
  const z = c(e);
  return [
    t,
    e,
    {
      blockSize: z.blockSize,
      inlineSize: z.inlineSize
    }
  ];
};
export {
  v as default
};
//# sourceMappingURL=useResizeObserver.js.map
